{
  "toolbar.search": "Search in the terminal…",
  "toolbar.searchButton": "Search (Ctrl+Shift+F)",
  "toolbar.copy": "Copy selection",
  "toolbar.paste": "Paste",
  "toolbar.fontDecrease": "Decrease font size",
  "toolbar.fontIncrease": "Increase font size",
  "toolbar.theme": "Change theme (dark, light, contrast)",
  "toolbar.pedagogy": "Courses and challenges",
  "toolbar.menu": "Menu",
  "menu.theme": "Theme",
  "menu.themeDark": "Dark",
  "menu.themeLight": "Light",
  "menu.themeContrast": "High contrast",
  "menu.colors": "Colour the console",
  "menu.clear": "Clear screen",
  "menu.about": "About",
  "menu.cheatsheets": "Download the cheat sheets",
  "menu.export": "Export my backup",
  "menu.import": "Import a backup",
  "menu.reset": "Reset the Debian machine",
  "menu.deleteAccount": "Delete my account",
  "menu.lock": "Lock session",
  "menu.logout": "Log out",
  "panel.title": "Courses",
  "panel.tabActive": "In progress",
  "panel.tabTutorials": "Tutorials",
  "panel.tabChallenges": "Challenges",
  "panel.tutorialBadge": "Tutorial",
  "panel.challengeBadge": "Challenge",
  "panel.difficulty": "difficulty",
  "panel.journal": "Journal",
  "panel.journalEmpty": "Validations will appear here.",
  "panel.flagLabel": "Flag NSI{…}",
  "panel.flagSubmit": "Submit",
  "panel.stop": "Give up",
  "panel.browseTutorials": "Browse tutorials",
  "panel.browseChallenges": "Browse challenges",
  "panel.fontDecrease": "Reduce panel font size",
  "panel.fontIncrease": "Increase panel font size",
  "panel.legend": "○ to do · ▶ in progress · ✓ done",
  "panel.close": "Close panel",
  "panel.emptyIntro": "Pick a tutorial or a challenge in the tabs.",
  "panel.emptyHint": "Your progress is stored in your account.",
  "panel.startTutorial": "Start this tutorial",
  "panel.startChallenge": "Start this challenge",
  "panel.hint": "Hint",
  "panel.skip": "Skip",
  "panel.level": "Level",
  "panel.badge": "badge",
  "panel.badges": "badges",
  "panel.tutorialsCount": "Tutorials",
  "panel.challengesCount": "Challenges",
  "panel.tutorialByTrack": "Tutorials by track",
  "panel.challengeByLevel": "Challenges by level",
  "panel.tutorialPrefix": "Tutorial —",
  "panel.challengePrefix": "Challenge —",
  "panel.step": "Step",
  "panel.challengeGoal": "Find the flag, then submit it below",
  "status.local": "local — no data sent"
}
